import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'

export function useInvalidateRows(module: string) {
  const queryClient = useQueryClient()

  return useCallback(() => {
    return queryClient.invalidateQueries([module, 'rows'])
  }, [module, queryClient])
}
